import { render, staticRenderFns } from "./TgCardInfoItem.vue?vue&type=template&id=be831cf2&"
import script from "./TgCardInfoItem.vue?vue&type=script&lang=js&"
export * from "./TgCardInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports